/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ManageProgramDto } from '../models/ManageProgramDto';
import type { ProgramDataDto } from '../models/ProgramDataDto';
import type { ProgramDto } from '../models/ProgramDto';
import type { ProgramMonthlyReportDto } from '../models/ProgramMonthlyReportDto';
import type { ProgramTaskConfigDto } from '../models/ProgramTaskConfigDto';
import type { ProgramTaskHistoryDto } from '../models/ProgramTaskHistoryDto';
import type { SimpleChekInDto } from '../models/SimpleChekInDto';
import type { TargetChangeAnswerDto } from '../models/TargetChangeAnswerDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProgramService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns ProgramMonthlyReportDto
     * @throws ApiError
     */
    public getMonthlyReports(): CancelablePromise<Array<ProgramMonthlyReportDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/program/monthly-reports',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public getGeneralStats(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/program/stats',
        });
    }

    /**
     * @param date
     * @returns ProgramTaskHistoryDto
     * @throws ApiError
     */
    public tasksForDate(
        date: string,
    ): CancelablePromise<ProgramTaskHistoryDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/program/task/{date}',
            path: {
                'date': date,
            },
        });
    }

    /**
     * @returns ProgramTaskHistoryDto
     * @throws ApiError
     */
    public last2Tasks(): CancelablePromise<Array<ProgramTaskHistoryDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/program/tasks/last-2',
        });
    }

    /**
     * @param date
     * @returns ProgramTaskHistoryDto
     * @throws ApiError
     */
    public tasksForMonth(
        date: string,
    ): CancelablePromise<Array<ProgramTaskHistoryDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/program/tasks/{date}',
            path: {
                'date': date,
            },
        });
    }

    /**
     * @param patientId
     * @returns ProgramDataDto
     * @throws ApiError
     */
    public allProgramData(
        patientId: string,
    ): CancelablePromise<ProgramDataDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/program/data/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }

    /**
     * @returns ProgramDto
     * @throws ApiError
     */
    public myProgram(): CancelablePromise<ProgramDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/program/my',
        });
    }

    /**
     * @param requestBody
     * @returns ManageProgramDto
     * @throws ApiError
     */
    public upsert(
        requestBody: ManageProgramDto,
    ): CancelablePromise<ManageProgramDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/program',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns ProgramDto
     * @throws ApiError
     */
    public updateProgramByUser(
        requestBody: ProgramTaskConfigDto,
    ): CancelablePromise<ProgramDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/program/by-user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns ProgramDto
     * @throws ApiError
     */
    public simpleCheckIn(
        requestBody: SimpleChekInDto,
    ): CancelablePromise<ProgramDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/program/simple-check-in',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns string
     * @throws ApiError
     */
    public getCheckInDates(): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/program/check-ins',
        });
    }

    /**
     * @param patientId
     * @returns any
     * @throws ApiError
     */
    public delete(
        patientId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/program/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }

    /**
     * @param patientId
     * @returns ProgramDto
     * @throws ApiError
     */
    public getForPatient(
        patientId: string,
    ): CancelablePromise<ProgramDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/program/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }

    /**
     * @returns ProgramDto
     * @throws ApiError
     */
    public markIntroAsViewed(): CancelablePromise<ProgramDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/program/intro-viewed',
        });
    }

    /**
     * @param requestBody
     * @returns ProgramDto
     * @throws ApiError
     */
    public answerTargetChangeQuestion(
        requestBody: TargetChangeAnswerDto,
    ): CancelablePromise<ProgramDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/program/target-change-answer',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public enableDefaultDailyReminders(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/program/enable-daily-reminders',
        });
    }

}
